<div id="change-document" class="change-document">
    <div *ngIf="showThanksIcon" class="cross-mark" (click)="onBackClose()">
        <img src="assets/images/smallclose.svg">
    </div>
    <div *ngIf="showThanksIcon" class="body bil-font-regular-large bil-font-weight box-padding image-center"
        [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile}">
        <img src="assets/images/Group 1.svg">
    </div>
    <div *ngIf="!showThanksIcon" class="body bil-font-regular-large bil-font-weight box-padding"
        [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile,'bil-font-Bold-head':data?.requestForModal?.message === 'Credit Card'}">
        {{data?.requestForModal?.message}}
    </div>
    <div class="bil-font-regular-large bil-font-weight bil-font-black box-padding"
        *ngIf="data?.requestForModal?.subheading">
        {{data?.requestForModal?.subheading}}
    </div>
    <div class="file-name-label" *ngIf="data?.requestForModal?.file_text">
        <div class="bil-document-label-icon">
            <img src="assets/images/single.svg" class="icon-style" />
        </div>
        <div class="bil-document-label-text">
            <span class="bil-font-small ">
                {{data?.requestForModal?.file_text}}
            </span>
        </div>
    </div>
    <div *ngIf="data?.requestForModal?.message !== 'Credit Card'" id="footer" class="bil-space-between bil-flex-wrap"
        [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile}">
        <span><a class="bil-font-regular bil-font-info-text"
                (click)="onBack()">{{data.requestForModal?.backLabel}}</a></span>
        <span></span>
        <span>
            <button type="button" mat-raised-button color="primary" class="bil-right-float"
                (click)="onNext()">{{data.requestForModal?.submitButtonName}}</button>
        </span>
    </div>
    <div *ngIf="!showThanksIcon">
        <div *ngIf="data?.requestForModal?.message === 'Credit Card'" id="footer"
            class="bil-space-between bil-flex-wrap yes-no-button-alignment"
            [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile}">
            <span><a class="bil-font-regular bil-font-info-text"
                    (click)="onBack()">{{data.requestForModal?.backLabel}}</a></span>
            <span></span>
            <span>
                <button type="button" mat-raised-button color="primary" class="bil-right-float yes-button-alignment"
                    (click)="onNext()">{{data.requestForModal?.submitButtonName}}</button>
            </span>
        </div>
    </div>

</div>